import { Device } from '../../api'

const initialState = () => {
    return {
        batteriesArray: [],
        projectEui: null,
    }
}

export const batteries = {
    namespaced: true,
    state: initialState(),
    actions: {
        async fetchBatteries({ commit, rootState }) {
            const projectEui = rootState.project.nameEui
            try {
                const batteries = await Device.get('PulseVolt')
                if (rootState.project.nameEui !== projectEui) return
                if (!Array.isArray(batteries.data)) throw new Error('Invalid PulseVolt catalog response')
                commit('SET_BATTERIES', { devices: batteries.data, projectEui })
            } catch (error) {
                if (rootState.project.nameEui !== projectEui) return
                commit('SET_BATTERIES', { devices: [], projectEui })
                throw { type: 'battery', error }
            }
        },
        flowParameters({}, pulsevolt){
            if(Object.keys(pulsevolt).length === 0) return {}
            const { ElectricInverter, Status } = pulsevolt?.functions;
            const battery = ElectricInverter?.BatElectricMeter?.power || 0;
            const grid = ElectricInverter?.GridElectricMeter?.power || 0;
            const load = ElectricInverter?.LoadElectricMeter?.power || 0;
            const isOnline = Status.online
            return {
                isOnline,
                battery: (battery/1000).toFixed(2),
                grid: (grid/1000).toFixed(2),
                load: (load/1000).toFixed(2),
                batteryCharge: ElectricInverter?.BatElectricMeter?.soc1 || 0
            }
        }
    },
    mutations: {
        SET_BATTERIES(state, { devices, projectEui }) {
            state.batteriesArray = devices
            state.projectEui = projectEui
        },
        RESET(state) {
            Object.assign(state, initialState())
        }
    },
}
